import index from './index.common'
export default index



/** WEBPACK FOOTER **
 ** ../~/eslint-loader?configFile=./other/src.eslintrc!./index.js
 **/